module.exports = __webpack_public_path__ + "assets/6c07197b5ec22fee464a32de0d2de9e7.png";